import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Grid, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { fetchLocalidades } from "../../../actions/cbos/localidades";
import { fetchProvincias } from "../../../actions/cbos/provincias";
import { getMiCartillaMiOspedyc } from "../../../actions/webAfiliado/cartillaMiOspedycActions";
import { ItemCartilla } from "./ItemCartilla";
import LoadingBeforeViewData from "../../compartidos/LoadingBeforeViewData";
import BarCartilla from "./BarCartilla";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1rem",
        marginBottom: "3rem"
    },
    textRadios: {
        fontWeight: "bold",
        textTransform: 'capitalize'
    },
    title: {
        fontWeight: "bold",
    },
    containerItemsCatilla: {
        marginTop: "2.5rem"
    },
}));

export const MiCartilla = () => {

    const classes = useStyles();
    const dispatch = useDispatch()

    const { miCartilla } = useSelector((state) => state.cartillaMiOspedyc);

    useEffect(() => {
        dispatch(fetchProvincias())
        dispatch(fetchLocalidades())
        dispatch(getMiCartillaMiOspedyc())
        // eslint-disable-next-line
    }, [])

    if (miCartilla === null)
        return <LoadingBeforeViewData />

    return (
        <div className={classes.root}>
            <Typography align="center" variant="h4" color="primary" className={classes.title}>Cartilla</Typography>
            <BarCartilla />
            <Container maxWidth="lg">
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                >
                    <Grid item xs={12} className={classes.containerItemsCatilla} >
                        <Container>
                            <Grid container spacing={5}>
                                {
                                    miCartilla.length === 0 &&
                                    <Grid item xs={12}><Typography color="secondary" variant="subtitle1" align="center" style={{ fontWeight: "bold" }}>No hay datos de cartilla para mostrar</Typography></Grid>
                                }
                                {
                                    miCartilla.map((item, index) =>
                                        <Grid key={index} item xs={12} sm={6}>
                                            <ItemCartilla item={item} />
                                        </Grid>
                                    )
                                }
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};
